/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import { FC } from 'react';
import { AutoComplete } from 'antd';
import { clsx } from 'clsx';

import { HeaderSearchInput } from '../../headerSeacrhInput/ui';
import { IHeaderSearchDropdownProps } from '../models/types';
import { HeaderSearchDropdownProvider } from '../providers';

import styles from './styles.module.scss';

export const HeaderSearchDropdown: FC<IHeaderSearchDropdownProps> = ({
  className,
  onSelect,
  onChange,
  onFocus,
  onBlur,
  options,
  placeholder,
  style,
  value,
  isLoading,
  onClearClick,
}) => {
  return (
    <div>
      <HeaderSearchDropdownProvider>
        <AutoComplete
          className={clsx([styles['search-dropdown'], className])}
          value={value}
          options={options}
          onSelect={onSelect}
          onFocus={onFocus}
          onBlur={onBlur}
          listHeight={327} // Установка высоты списка
        >
          <HeaderSearchInput
            placeholder={placeholder}
            onChange={onChange}
            value={value as string}
            isLoading={isLoading}
            onClearClick={onClearClick}
            style={{
              ...style,
            }}
          />
        </AutoComplete>
      </HeaderSearchDropdownProvider>
    </div>
  );
};
